import { render, staticRenderFns } from "./SpecialBiwako202306.vue?vue&type=template&id=4c04ec5d&scoped=true"
import script from "./SpecialBiwako202306.vue?vue&type=script&lang=js"
export * from "./SpecialBiwako202306.vue?vue&type=script&lang=js"
import style0 from "./SpecialBiwako202306.vue?vue&type=style&index=0&id=4c04ec5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c04ec5d",
  null
  
)

export default component.exports